<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_digitCouples') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') }}
            span(slot="value") {{ parameters.amountOfPairs }}
        game-preview-setting(v-for="(difficult, index) in selectedDifficulties" :key="difficult")
            span(slot="name") {{ index === 0 ? $i18n.t('trainer.trainer_gameFormSetting_difficulty') : '' }}
            span(slot="value") {{ difficult }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_viewTypeLeft') }}
            span(slot="value") {{ $i18n.t('couples.couples_view_' + parameters.leftColumn)  }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_viewTypeRight') }}
            span(slot="value") {{ $i18n.t('couples.couples_view_' + parameters.rightColumn) }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            selectedDifficulties () {
                return this.parameters.difficulties.map(difficult => {
                    switch (difficult) {
                        case ('equality'):
                            return this.$i18n.t('trainer.trainer_gameFormSettingValue_equality');
                        case ('inequality'):
                            return this.$i18n.t('trainer.trainer_gameFormSettingValue_inequality');
                        default:
                            return this.$i18n.t('trainer.trainer_gameFormSettingValue_numberComposition', {
                                n: +difficult
                            })
                    }
                })
            }
        }
    }
</script>
